import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainplaceComponent } from './mainplace/mainplace.component';
import { PlaceEditorComponent } from './place-editor/place-editor.component';
import { FormsModule } from '@angular/forms';
import { PlaceMainComponent } from './place-main/place-main.component';
import { PlacesComponent } from './places/places.component';
import { DropMenuModule } from '../drop-menu/drop-menu.module';
import { MediaGalleryModule } from '../media-gallery/media-gallery.module';
import { PlacesEditorTempComponent } from './places-editor-temp/places-editor-temp.component';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';
import { ImageCarouselTempModule } from '../image-carousel-temp/image-carousel-temp.module';
import { EventsModule } from '../events/events.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PlaceEditorPageComponent } from './place-editor-page/place-editor-page.component';
import { PlaceEditorPageFieldsComponent } from './place-editor-page-fields/place-editor-page-fields.component';
import { PlaceEditorPageListComponent } from './place-editor-page-list/place-editor-page-list.component';



@NgModule({
  declarations: [PlaceMainComponent, PlacesComponent, PlacesEditorTempComponent, PlaceEditorPageComponent, PlaceEditorPageFieldsComponent, PlaceEditorPageListComponent],
  imports: [
    CommonModule,
    FormsModule,
    DropMenuModule,
    MediaGalleryModule, 
    ImageCarouselTempModule,
    EventsModule,
    SharedModule
  ]
})
export class PlaceModule { }

// translation loader moved to SharedModule
